import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SaasOrderManageService {
   prefix: string = environment.saasWebAPI;

   constructor(
     private http: SwHttpClientService
   ) {}

  //查询列表
  queryPageList(param) {
    const url = this.prefix + 'order/queryPageList';
    return this.http.Post(url, param);
  }

  //查看 
  queryById(param) {
    const url = this.prefix + 'order/queryById';
    return this.http.Post(url, param);
  }

  //审核
  approveById(param) {
    const url = this.prefix + 'order/approveOrder';
    return this.http.Post(url, param);
  }
}
